import ko from 'knockout';
import _ from 'lodash';
import $ from 'jquery';

const selectorIds = {
	'1': 'input:visible:first',
	'2': 'button:visible:first',
	'3': 'label:visible:first',
};

const onFocus = (element, valueAccessor) => {
	const {id = 1, target, when: whenCan = _.noop} = valueAccessor() || {};
	const $target = target ? $(target) : $(element).find(selectorIds[id]); // take default

	if (whenCan() && $target.focus) {
		_.delay(() => $target.focus(), 50);
	}
};

const createBinding = (onInit, onUpdate) => ({
	init: onInit,
	update: onUpdate,
});

ko.bindingHandlers.autoFocus = createBinding(onFocus, onFocus);
